import { z } from 'zod';


/**
 * Membership in a share group
 */
export const shareGroupMemberSchema = z.object({
  id: z.string(),
  userId: z.string().nullable(),
  avatar_url: z.string().nullable().optional(),
  role: z.enum(['owner', 'member']),
  status: z.enum(['invited', 'active']),
  invitedEmail: z.string().nullable().optional(),
  joinedAt: z.string()
})
;
export type ShareGroupMember = z.infer<typeof shareGroupMemberSchema>;

/**
 * Share group for collaborative food/recipe sharing
 */
export const shareGroupSchema = z
  .object({
    id: z.string(),
    name: z.string(),
    created_by: z.string(),
    created_at: z.string(),
    updated_at: z.string(),
    memberCount: z.number(),
    userRole: z.enum(['owner', 'member']),
    members: z.array(shareGroupMemberSchema),
  })
  ;
export type ShareGroup = z.infer<typeof shareGroupSchema>;



/**
 * Shared food item in a share group
 */
export const sharedFoodSchema = z.object({
  id: z.string(),
  foodId: z.string(),
  shareGroupId: z.string(),
  sharedByUserId: z.string(),
  sharedAt: z.string(),
  importedByUserIds: z.array(z.string())
});
export type SharedFood = z.infer<typeof sharedFoodSchema>;

/**
 * Shared recipe in a share group
 */
export const sharedRecipeSchema = z.object({
  id: z.string(),
  recipeId: z.string(),
  shareGroupId: z.string(),
  sharedByUserId: z.string(),
  sharedAt: z.string(),
  importedByUserIds: z.array(z.string()),
  originalRecipeId: z.string(),
  lastUpdatedAt: z.string()
});
export type SharedRecipe = z.infer<typeof sharedRecipeSchema>;

/**
 * Imported recipe tracking for versioning
 */
export const importedRecipeSchema = z.object({
  id: z.string(),
  userId: z.string(),
  importedRecipeId: z.string(),
  originalRecipeId: z.string(),
  shareGroupId: z.string(),
  importedAt: z.string(),
  lastSyncAt: z.string(),
  hasLocalChanges: z.boolean()
});
export type ImportedRecipe = z.infer<typeof importedRecipeSchema>;